// TODO: Convert assessment-setup.html to this component
// Use: useMutation with saveRequirements from assessmentService

export default function AssessmentSetupPage() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>🎯 Assessment Setup</h1>
      <p style={{ color: 'var(--text-secondary)' }}>
        Configure assessment criteria
      </p>
    </div>
  )
}
